import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGraduateCap: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconGraduateCap"><Path d="M11.999 2.90625L0.160156 8.99976L11.999 15.0933L22.3491 9.76607V15.9998H23.8491V8.99976H23.8379L11.999 2.90625Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M4.49902 12.7298V17.2999L11.999 21.118L19.499 17.2999V12.7298L11.999 16.5898L4.49902 12.7298Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGraduateCap;
